"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var __1 = require("../..");
var TableSkeleton = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b;
    var amount = __spreadArray([], Array(10), true);
    return ((0, jsx_runtime_1.jsx)(material_1.Stack, __assign({ spacing: "1.6rem" }, { children: (0, jsx_runtime_1.jsx)(material_1.Stack, __assign({ spacing: size === 'small' ? '0.8rem' : '1.6rem' }, { children: amount.map(function (_, index) { return ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ height: size === 'small' ? '4.0rem' : '9.0rem', sx: {
                    display: 'flex',
                    alignItems: 'center',
                    boxShadow: '0px 12px 50px rgba(80, 41, 239, 0.04)',
                } }, { children: (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", justifyContent: "space-around", width: "100%" }, { children: [(0, jsx_runtime_1.jsx)(__1.Skeleton, { width: size === 'small' ? 50 : 120, height: 20 }), (0, jsx_runtime_1.jsx)(__1.Skeleton, { width: size === 'small' ? 40 : 100, height: 20 }), (0, jsx_runtime_1.jsx)(__1.Skeleton, { width: size === 'small' ? 30 : 140, height: 20 }), (0, jsx_runtime_1.jsx)(__1.Skeleton, { width: size === 'small' ? 60 : 100, height: 20 }), (0, jsx_runtime_1.jsx)(__1.Skeleton, { width: size === 'small' ? 50 : 100, height: 20 })] })) }), index)); }) })) })));
};
exports.default = TableSkeleton;
